import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-landing-popup',
  templateUrl: './landing-popup.component.html',
  styleUrls: ['./landing-popup.component.less']
})
export class LandingPopupComponent implements OnInit {
  @Output() closePopup = new EventEmitter<void>();
  showPopup: boolean = false;

  constructor() { }

  ngOnInit(): void {
    setTimeout(() => {
      this.showPopup = true;
    }, 500);
  }

  close(redirect:boolean = false) {
    if (redirect)
      window.open(environment.downloadEkoApp, '_blank');
    this.closePopup.emit();
  }
}
